import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/community-portal/community-portal/src/modules/layouts/mdx_layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Accordion = makeShortcode("Accordion");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    {
      /* ---
      title: Contributor Onboarding
      order: 10
      hideLanguageSelector: true
      keywords: "makerdao contribute"
      description: "This onboarding guide walks new members through the ins and outs of contributing to MakerDAO through Community Development (Comm-Dev)."
      --- */
    }
    <h1>{`Contributor Onboarding Guide`}</h1>
    <p>{`This onboarding guide walks new members through the ins and outs of contributing to MakerDAO through Community Development (Comm-Dev). Writers, designers, editors, developers, and anyone with relevant skill sets are welcome to participate.`}</p>
    <p>{`Get started with a few initial steps.`}</p>
    <Accordion mdxType="Accordion">
      <h2>{`Learn About MakerDAO`}</h2>
      <p>{`Invest some time in gaining a well-rounded knowledge of MakerDAO and help make better contributions.`}</p>
      <ul>
        <li parentName="ul">{`Study the `}<a parentName="li" {...{
            "href": "/learn/"
          }}>{`learn section of the site`}</a>{` to understand Maker, Dai, and MakerDAO.`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/governance_and_risk_meetings/"
          }}>{`Learn how the protocol is managed through governance.`}</a></li>
        <li parentName="ul">{`Take advantage of `}<a parentName="li" {...{
            "href": "https://github.com/makerdao/awesome-makerdao"
          }}>{`Awesome-MakerDAO`}</a>{` to become familiar with MakerDAO’s history, current events, and the latest relevant information.`}</li>
      </ul>
    </Accordion>
    <Accordion mdxType="Accordion">
      <h2>{`Explore Ways to Earn as a Contributor`}</h2>
      <p>{`MakerDAO is ever-growing. Comm-Dev invites contributors to explore the many ways to earn as a contributor by finding tasks that match their skills and interests.`}</p>
      <ul>
        <li parentName="ul">{`Build Onboarding Guides like this one`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/meetups/"
          }}>{`Organize Meetups`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/meetups/"
          }}>{`Improve Meetup Guides`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/"
          }}>{`Translate MakerDAO Resources`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/governance_and_risk_meetings/summaries/"
          }}>{`Write Risk & Governance Meeting Summaries`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/makerdao/awesome-makerdao"
          }}>{`Curate Awesome-MakerDAO`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/hackathons/"
          }}>{`Participate in a Hackathon`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/makerdao/community/projects/2?card_filter_query=label%3A%22help+wanted%22"
          }}>{`Explore open bounties with Help-Wanted label`}</a>{` or `}<a parentName="li" {...{
            "href": "https://forum.makerdao.com/c/comm-dev/help-wanted/11"
          }}>{`Browse Help-Wanted section of the MakerDAO Forum`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/funding/community-projects/community-projects-process/"
          }}>{`Propose initiatives with a Community Development Improvement Proposal (CDIP)`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/funding/development-grants/"
          }}>{`Apply for a Development Grant for a Large Project`}</a></li>
      </ul>
    </Accordion>
    <Accordion mdxType="Accordion">
      <h2>{`Express Interest`}</h2>
      <ul>
        <li parentName="ul">{`Join the `}<a parentName="li" {...{
            "href": "https://chat.makerdao.com/channel/community-development"
          }}>{`#community-development`}</a>{` channel on MakerDAO’s chat.`}</li>
        <li parentName="ul">{`If a contribution does not fall within these scopes, discuss personal interests and relevant skills to the Contributing Team to help determine a well-suited project.`}</li>
        <li parentName="ul">{`Provide relevant examples of past projects, work, and experience.`}</li>
        <li parentName="ul">{`Resumes are appreciated, but not required.`}</li>
        <li parentName="ul">{`Demonstrate a reliable work ethic and offer quality work that speaks for itself.`}</li>
        <li parentName="ul">{`In-depth knowledge is appreciated but not required.`}</li>
        <li parentName="ul">{`Stand out by suggesting projects and adding insight to public discussions.`}</li>
        <li parentName="ul">{`Technical assignments are reserved for contributors that have the required background knowledge or skills.`}</li>
      </ul>
    </Accordion>
    <Accordion mdxType="Accordion">
      <h2>{`Get Started - Roles and Types of Projects`}</h2>
      <p>{`Learn about the existing Community Development (Comm-Dev) contributor framework.`}</p>
      <h3>{`Roles`}</h3>
      <p>{`Comm-Dev contributors assume various roles throughout the process of creating and working on MakerDAO’s community resources and initiatives. As projects evolve, contributors often take turns assuming the roles of Advisor, Lead, Writer, and Reviewer.`}</p>
      <p><strong parentName="p">{`Approver`}</strong></p>
      <p>{`Approvers review final Comm-Dev submissions and have the authority to approve completed projects or request further revisions.`}</p>
      <ul>
        <li parentName="ul">{`Approvers are responsible for providing clear expectations for project completion.`}</li>
        <li parentName="ul">{`Approvers are defined at the onset of new projects.`}</li>
        <li parentName="ul">{`Projects may have more than one Approver at any given stage.`}</li>
        <li parentName="ul">{`Approvers must be comfortable reviewing Pull Requests for GitHub submissions.`}</li>
      </ul>
      <p>{`*`}<strong parentName="p">{`*Note:`}</strong>{` The Approver role is not openly available to anyone.*`}</p>
      <pre><code parentName="pre" {...{}}>{`*    *Generally, Approvers are domain experts, vetted or experienced members, or stakeholders.*
`}</code></pre>
      <p><strong parentName="p">{`Lead`}</strong></p>
      <p>{`A Lead spearheads Comm-Dev projects. Functionally, Leads act as project owners.`}</p>
      <ul>
        <li parentName="ul">{`A Lead is responsible for:`}
          <ul parentName="li">
            <li parentName="ul">{`Defining a plan and project roadmap.`}</li>
            <li parentName="ul">{`Providing updates.`}</li>
            <li parentName="ul">{`Setting up GitHub issues.`}</li>
            <li parentName="ul">{`Coordinating with stakeholders.`}</li>
            <li parentName="ul">{`Generally overseeing projects and ensuring that they run smoothly.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`New Leads should turn to an Advisor for support.`}</li>
      </ul>
      <p><strong parentName="p">{`Advisor`}</strong></p>
      <p>{`An Advisor is a supporting role that assists Leads throughout a project’s process to help bring it to completion.`}</p>
      <ul>
        <li parentName="ul">{`An Advisor:`}
          <ul parentName="li">
            <li parentName="ul">{`May be tasked with helping onboard new contributors.`}</li>
            <li parentName="ul">{`Should be well versed with any processes they provide support for.`}</li>
            <li parentName="ul">{`May act as a temporary project manager.`}</li>
            <li parentName="ul">{`Should consider an individual contributor’s strengths and abilities to help assign appropriate projects or tasks.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`One of the Advisor’s main goals is training contributors to ensure that they manage the responsibilities of their roles effectively.`}</li>
      </ul>
      <p><strong parentName="p">{`Writer`}</strong></p>
      <p>{`A Writer produces Comm-Dev content and resources.`}</p>
      <ul>
        <li parentName="ul">{`Writers should be well versed with the `}<a parentName="li" {...{
            "href": "/contribute/content/writing-style-guide/"
          }}>{`Writing Style Guide.`}</a></li>
        <li parentName="ul">{`Some projects will require coordination between multiple Writers.`}</li>
        <li parentName="ul">{`Contributors can assume either the Writer or Reviewer role, but not for the same project.`}</li>
      </ul>
      <p><strong parentName="p">{`Reviewer`}</strong></p>
      <p>{`A Reviewer assesses written content for formatting and grammatical errors, consistency, and tone.`}</p>
      <ul>
        <li parentName="ul">{`Reviewers should be well versed with the `}<a parentName="li" {...{
            "href": "/contribute/content/reviewer-guide/"
          }}>{`Reviewer`}</a>{` and `}<a parentName="li" {...{
            "href": "/contribute/content/writing-style-guide/"
          }}>{`Writing Style`}</a>{` Guides.`}</li>
        <li parentName="ul">{`Reviewers are responsible for communicating changes and the reasons behind them to the Writer(s).`}</li>
        <li parentName="ul">{`Reviewers should give constructive feedback and convey any mistakes to the Writer(s).`}</li>
        <li parentName="ul">{`Documents may have multiple Reviewers at any given stage.`}</li>
        <li parentName="ul">{`Contributors can assume either the Writer or Reviewer role, but not for the same project.`}</li>
      </ul>
      <p><strong parentName="p">{`Contributing Team`}</strong></p>
      <p>{`A Contributing Team is a core group of contributors responsible for a given ongoing Comm-Dev project.`}</p>
      <ul>
        <li parentName="ul">{`A Contributing Team may consist of a Designer, Writer, Reviewer, and Approver, for example.`}</li>
        <li parentName="ul">{`Small projects may have temporary Contributing Teams.`}</li>
        <li parentName="ul">{`Established Contributing Teams that work well together may oversee larger projects.`}</li>
      </ul>
      <h3>{`Types of Projects`}</h3>
      <p>{`Many Comm-Dev projects are cross-functional with unique workflows, but they generally fall into three main categories: Resources, Initiatives, and Workflow.`}</p>
      <h4>{`Resources`}</h4>
      <p>{`Comm-Dev resource materials are classified into two main categories: Educational and Reference. Projects with defined categories give content creators direction, however, some resources may fall into overlapping resource categories (e.g., Onboarding Guides). The Contributing Team will decide whether a project is an Educational or Reference resource. Writers and Reviewers will adjust their writing style appropriately.`}</p>
      <p><strong parentName="p">{`Educational and Reference Materials`}</strong></p>
      <ul>
        <li parentName="ul">{`Educational resources teach visitors about MakerDAO and its protocol. These resources cater to a broad audience and approach concepts with varying levels of complexity. The ultimate idea is to turn novices into experts.`}
          <ul parentName="li">
            <li parentName="ul">{`Examples include Awesome-MakerDAO, Onboarding Guides, and more.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`Reference materials typically cater to a specialized audience. These are resources that can be used as canonical documentation.`}
          <ul parentName="li">
            <li parentName="ul">{`They present precise, documented details about a given domain.`}</li>
            <li parentName="ul">{`Examples include the Governance Call summaries, Contributor Guides, Meetup Guides, Onboarding Guides, and more.`}</li>
          </ul>
        </li>
      </ul>
      <p>{`Educational and reference materials may be in any form (e.g., videos, written documents, pictures, etc.) In producing this type of content, there should be careful attention paid to keeping information up-to-date and factual, as well as reducing the barrier to entry for newer readers by providing effective cross-linking and a clear and succinct tone. A contributor’s knowledge on the topic should be closely considered before a project to produce educational or reference materials is approved.`}</p>
      <h4>{`Educational and Reference Documentation Process`}</h4>
      <p>{`Creating and updating educational and reference materials may require Writers and Reviewers to pass a document back and forth for several iterations before handing it off to an Approver for final review. Therefore, Comm-Dev follows a documentation process model, pictured below, for the flow of a resource from inception to publication.`}</p>
      <p><img parentName="p" {...{
          "src": "/images/educational-reference-documentation-process.jpg",
          "alt": "Educational and Reference Documentation Process"
        }}></img></p>
      <ul>
        <li parentName="ul">{`Certain resources require more steps, depending on the content.`}</li>
        <li parentName="ul">{`V0, V1, and V2 are used to reference the maturity of resources.`}</li>
        <li parentName="ul">{`Numbers after the decimal (V0.1, V1.4), outline the draft versions within a version.`}
          <ul parentName="li">
            <li parentName="ul">{`On Google Docs, name and save the document with each updated version.`}</li>
            <li parentName="ul">{`When moving from Google Docs to HackMD, avoid confusion around assessing outdated documents by highlighting the most updated document link on the very top of the outdated document.`}</li>
            <li parentName="ul">{`For more best practices, follow the `}<a parentName="li" {...{
                "href": "/contribute/content/contributor-tools/"
              }}>{`Contributor Tools Guide`}</a>{`.`}</li>
          </ul>
        </li>
      </ul>
      <h4>{`Initiatives`}</h4>
      <p>{`Initiatives are projects that produce a plan or new process aimed at improving the contributor community experience or the production and upkeep of MakerDAO community resources.`}</p>
      <ul>
        <li parentName="ul">{`Examples include the Quarterly Maintenance Cycle, Meetup Grants, CDIPs, Community Translations, and Hackathons.`}</li>
        <li parentName="ul">{`New initiatives focus on iterative processes to validate the value of the idea.`}
          <ul parentName="li">
            <li parentName="ul">{`Plans define outcomes, goals, and audience.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`As initiatives prove their value, focus shifts to growth and scaling processes, as well as defining and measuring success factors.`}
          <ul parentName="li">
            <li parentName="ul">{`The Contributing Team should review the cost to impact ratio and efficiency of a process.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`If initiatives stall, plateau, or reach a natural dead end, they may need to be reassessed.`}
          <ul parentName="li">
            <li parentName="ul">{`The Contributing Team should use this opportunity to reflect on their goals and priorities.`}</li>
          </ul>
        </li>
      </ul>
      <h4>{`Workflow`}</h4>
      <p>{`Projects classified as “Workflow” focus on improving team dynamics and productivity.`}</p>
      <ul>
        <li parentName="ul">{`An example of a Workflow project is the `}<a parentName="li" {...{
            "href": "https://github.com/makerdao/community/projects/6"
          }}>{`Contributing Section Sprint.`}</a>
          <ul parentName="li">
            <li parentName="ul">{`A two week sprint process brought new and existing MakerDAO community members together to create guides for improving the contributing experience.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`Contributors working on Workflow projects should focus on operations and effective task execution.`}</li>
      </ul>
    </Accordion>
    <Accordion mdxType="Accordion">
      <h2>{`Work on a Project`}</h2>
      <p>{`As the Contributing Team grows, project management evolves with it. Sharing logic and best practices within the team helps maintain and improve collaboration.`}</p>
      <h3>{`Community Guides`}</h3>
      <p>{`Review all contributor basic guides before starting any work on MakerDAO Community Development projects.`}</p>
      <p><strong parentName="p">{`Basics`}</strong></p>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/content/contributor-tools/"
          }}>{`Contributor Tools Guide`}</a>{`: Introduces the tools regularly used for developing and maintaining Comm-Dev resources.`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/content/writing-style-guide/"
          }}>{`Writing Style Guide`}</a>{`: Outlines Comm-Dev writing standards of tone and grammar.`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/content/reviewer-guide/"
          }}>{`Reviewer Guide`}</a>{`: Introduces the review process and outlines editing standards.`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/"
          }}>{`Earn as a Contributor`}</a>{`: Lists the different ways to earn Dai for contributions.`}</li>
      </ul>
      <p>{`Some resources have a project-specific guide. Be sure to check for one when working on an existing document.`}</p>
      <p>{`Specific Resources & Initiatives`}</p>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/content/"
          }}>{`Visual Style Guide`}</a>{`: Presents the Comm-Dev visual standards.`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/contribute/governance_and_risk_meetings/summaries/"
          }}>{`Governance and Risk Summary Guide`}</a>{`: Outlines instructions for producing Risk and Governance meeting call summaries.`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/funding/community-projects/"
          }}>{`Community-Development Initiative Proposal (CDIP)`}</a>{`: Describes the process contributors should follow when presenting their own ideas for a contribution.`}</li>
      </ul>
      <h3>{`Typical Workflow`}</h3>
      <p>{`Become familiar with how the Contributing Team works together.`}</p>
      <h4>{`Plan`}</h4>
      <p>{`Work with Advisors and other contributors to develop a plan that defines an approach for the assignment.`}</p>
      <ul>
        <li parentName="ul">{`Produce or read a project outline.`}
          <ul parentName="li">
            <li parentName="ul">{`Create clear, attainable goals.`}</li>
            <li parentName="ul">{`Set realistic timelines and deadlines.`}</li>
            <li parentName="ul">{`Define a range (minimum to maximum) of time expected to tackle the project.`}</li>
            <li parentName="ul">{`Take the time to document and clarify decisions.`}</li>
            <li parentName="ul">{`Ask as many questions as necessary before starting.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`Collaborate early and often.`}
          <ul parentName="li">
            <li parentName="ul">{`Establish an approach to split-up work. (e.g., work breakdown chart, list action items with owners and dates)`}</li>
            <li parentName="ul">{`Set clear roles and responsibilities, including for the Approver.`}</li>
            <li parentName="ul">{`Schedule regular syncs to avoid having two or more working on the same task simultaneously.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`If necessary, utilize a project template.`}
          <ul parentName="li">
            <li parentName="ul"><a parentName="li" {...{
                "href": "https://bit.ly/comm-dev-project-planning-template"
              }}>{`Project Planning Template`}</a></li>
            <li parentName="ul"><a parentName="li" {...{
                "href": "/funding/community-projects/"
              }}>{`CDIP Template`}</a></li>
            <li parentName="ul"><a parentName="li" {...{
                "href": "https://hackmd.io/vDXzQC6FQp6bc542_cK_0g"
              }}>{`Architecture for Initiative Landing Pages`}</a></li>
          </ul>
        </li>
      </ul>
      <h4>{`Execute`}</h4>
      <ul>
        <li parentName="ul">{`Be comfortable working with Google Docs, Markdown on HackMD, and GitHub. Refer to the `}<a parentName="li" {...{
            "href": "/contribute/content/contributor-tools/"
          }}>{`Contributor Tools Guide`}</a>{` for best practices.`}
          <ul parentName="li">
            <li parentName="ul">{`When starting a project from scratch, create the first draft in Google Docs.`}</li>
            <li parentName="ul">{`Save and name versions.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`Track projects and progress on `}<a parentName="li" {...{
            "href": "https://github.com/makerdao/community/projects/2"
          }}>{`Comm-Dev GitHub Issues.`}</a>
          <ul parentName="li">
            <li parentName="ul">{`Own and keep GitHub issues updated with comments and feedback.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`Communicate with the Contributing Team.`}
          <ul parentName="li">
            <li parentName="ul">{`Strive for succinct, straightforward communications that provide high-visibility for all contributors.`}</li>
            <li parentName="ul">{`When in doubt, voice context-driven questions and comments.`}</li>
          </ul>
        </li>
      </ul>
      <h4>{`Feedback and Review`}</h4>
      <ul>
        <li parentName="ul">{`Seek feedback at any point throughout a project, especially when stuck.`}</li>
        <li parentName="ul">{`Visit `}<a parentName="li" {...{
            "href": "https://chat.makerdao.com/channel/community-development"
          }}>{`#community-development chat channel`}</a>{` regularly to ask for feedback, provide progress updates and blockers, and coordinate with other members.`}</li>
        <li parentName="ul">{`Strive for weekly updates.`}</li>
        <li parentName="ul">{`Communicate with Reviewers for visibility.`}</li>
      </ul>
      <h4>{`Submit Final Drafts for Approval`}</h4>
      <ul>
        <li parentName="ul">{`Leads, Reviewers, and Advisors work together to determine when a project is ready for final review by the Approver.`}</li>
        <li parentName="ul">{`Transfer final drafts from Google Docs to HackMD.`}</li>
        <li parentName="ul">{`Submit completed projects for approval as `}<a parentName="li" {...{
            "href": "https://help.github.com/en/github/collaborating-with-issues-and-pull-requests/creating-a-pull-request"
          }}>{`Pull Requests`}</a>{` on GitHub.`}
          <ul parentName="li">
            <li parentName="ul">{`It is best practice to link the Pull Request to the issue.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`Update relevant issues on GitHub.`}</li>
        <li parentName="ul">{`Update the project board on GitHub, if necessary.`}</li>
      </ul>
      <h4>{`Retrospective`}</h4>
      <ul>
        <li parentName="ul">{`Sync asynchronously or on a call.`}</li>
        <li parentName="ul">{`Spend 30 minutes defining ‘what went well’, ‘what didn’t go well’, and ‘what could improve.’`}
          <ul parentName="li">
            <li parentName="ul">{`Document feedback.`}</li>
            <li parentName="ul">{`Utilize Tools like `}<a parentName="li" {...{
                "href": "https://funretro.io/"
              }}>{`Fun Retro`}</a>{`.`}</li>
          </ul>
        </li>
        <li parentName="ul">{`Relay learnings to the greater Comm-Dev team.`}</li>
      </ul>
    </Accordion>
    <p>{`Questions? Ask your questions in the `}<a parentName="p" {...{
        "href": "https://chat.makerdao.com/channel/community-development"
      }}>{`#community-development chat channel.`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      